import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IncludedInModule } from '@portal-core/general/pipes/included-in/included-in.module';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { ListModule } from '@portal-core/ui/list/list.module';
import { ProjectLicenseUsersListComponent } from './project-license-users-list.component';


@NgModule({
  declarations: [
    ProjectLicenseUsersListComponent
  ],
  imports: [
    CommonModule,
    ListModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    LicenseUserAvatarModule,
    IncludedInModule,
    MatSnackBarModule,
  ],
  exports: [
    ProjectLicenseUsersListComponent
  ]
})
export class ProjectLicenseUsersListModule { }
